// frontend_react/src/AppRoutes.jsx

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoute";
import AdminRoute from "./routes/AdminRoute";
import Layout from "./components/Layout";

import Home from "./pages/Home";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";
import ForgotPasswordClientPage from "./pages/auth/ForgotPasswordClientPage";
import ResetPasswordClientPage from "./pages/auth/ResetPasswordClientPage";
import EventRegister from "./pages/main/EventRegister";
import CustomerDashboardPage from "./pages/customer/CustomerDashboardPage";
import CustomerProfilePage from "./pages/customer/CustomerProfilePage";
import CustomerRegisterPage from "./pages/customer/CustomerRegisterPage";
import CustomerPlayerIdentifiersPage from "./pages/customer/CustomerPlayerIdentifiersPage";
import CustomerLoyaltyPage from "./pages/customer/CustomerLoyaltyPage";

import ProductSearch from "./pages/catalog/ProductSearch";
import Distributor from "./pages/distributor/Distributor";

import CartPage from "./pages/cart/CartPage";
import PendingCarts from "./pages/cart/PendingCarts";
import ProductionPOSRoute from "./pages/pos/ProductionPOSRoute";
import KitchenScreen from "./pages/kitchen/KitchenScreen";
import BarScreen from "./pages/kitchen/BarScreen";

// import ReceiptPrintSend from "./components/ReceiptPrintSend";
import ReceiptPageWrapper from "./pages/receipt/ReceiptPage";

import AdminDashboard from "./pages/admin/AdminDashboard";
import EmployeeWorkspaceRoute from "./pages/admin/hr/EmployeeWorkspaceRoute";
import ReceiptList from "./pages/admin/ReceiptList";
import ReceiptForm from "./pages/admin/ReceiptForm";
import ReplenishmentOrdersPage from './pages/admin/ReplenishmentOrdersPage';
import ReplenishmentStatusPage from './pages/admin/ReplenishmentStatusPage';
import BankingPage from "./pages/admin/BankingPage";
import ExportsPage from "./pages/admin/ExportsPage";
import LoyaltyAdminPage from "./pages/admin/LoyaltyAdminPage";
import MyCalendar from "./pages/calendar/MyCalendar";
import EventsPublicPage from "./pages/main/EventsPublicPage";
import EditEvent from "./pages/calendar/EditEvent";
import SupplierInvoiceValidationPage from "./pages/supplierInvoice/SupplierInvoiceValidationPage";
import SupplierInvoiceUploadPage from "./pages/supplierInvoice/SupplierInvoiceUploadPage";
import Restaurant from "./pages/restaurant/Restaurant";
import SalesDashboard from "./pages/sales/SalesDashboard";

import ProfilePage from "./pages/ProfilePage";
import ComingSoonPage from "./pages/ComingSoonPage";
import NotFound from "./pages/NotFound";

export default function AppRoutes() {
  return (
    <Routes>
      {/* PUBLIC */}
      <Route path="/" element={<Home />} />
      <Route path="/clients/new" element={<CustomerRegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="/forgot-password/client" element={<ForgotPasswordClientPage />} />
      <Route path="/reset-password-client/:token" element={<ResetPasswordClientPage />} />
      <Route path="/events" element={<EventsPublicPage />} />
      <Route path="/event/:eventUuid/register" element={<EventRegister />} />
      
      <Route path="/customer" element={<CustomerDashboardPage />} />
      <Route path="/customer/profile" element={<CustomerProfilePage />} />
      <Route path="/customer/player-identifiers" element={<CustomerPlayerIdentifiersPage />} />
      <Route path="/customer/loyalty" element={<CustomerLoyaltyPage />} />
      <Route path="/customer/events" element={<CustomerDashboardPage />} />
      <Route path="/customer/history" element={<CustomerDashboardPage />} />

      {/* PROTECTED LAYOUT */}
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        {/* Magasin */}
        <Route path="/products" element={<ProductSearch />} />

        {/* Fournisseurs */}
        <Route path="/supplier-invoices/:invoiceUuid/validate" element={<SupplierInvoiceValidationPage />} />
        <Route path="/supplier-invoices/upload" element={<SupplierInvoiceUploadPage />} />
        <Route path="/distributor" element={<Distributor />} />
        
        {/* Calendrier */}
        <Route path="/calendar" element={<MyCalendar />} />
        <Route path="/event/:eventUuid/edit" element={<EditEvent />} />
        <Route path="/event/create/edit" element={<EditEvent />} />

        {/* Ventes */}
        <Route path="/sales" element={<SalesDashboard />} />

        {/* Retail POS production */}
        <Route
          path="/pos/:activityUuid"
          element={<ProductionPOSRoute />}
        />

        {/* Cart & Double-Caisse */}
        <Route path="/cart" element={<CartPage />} />
        <Route path="/cart/pending" element={<PendingCarts />} />

        {/* Receipt & Print/Send */}
        <Route path="/receipt/:receiptUuid" element={<ReceiptPageWrapper />} />
        <Route path="/restaurant" element={<Restaurant />} />
        <Route path="/kitchen" element={<KitchenScreen />} />
        <Route path="/bar" element={<BarScreen />} />

        {/* Profil */}
        <Route path="/profil" element={<ProfilePage />} />
        <Route path="/profile" element={<ProfilePage />} />

        <Route
          path="/admin/loyalty"
          element={
            <AdminRoute>
              <LoyaltyAdminPage />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/hr/employees/:employeeUuid"
          element={
            <AdminRoute>
              <EmployeeWorkspaceRoute />
            </AdminRoute>
          }
        />

        {/* Admin Dashboard & espace Admin */}
        <Route
          path="/admin/*"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route
            path="hr"
            element={
              <Navigate
                to="/admin?panel=hr_employees"
                replace
              />
            }
          />
          <Route path="inventory/receipts" element={<ReceiptList />} />
          <Route path="inventory/receipts/new" element={<ReceiptForm />} />
          <Route path="inventory/receipts/:uuid" element={<ReceiptForm edit />} />
          <Route path="replenishment/orders" element={<ReplenishmentOrdersPage />} />
          <Route path="replenishment/status" element={<ReplenishmentStatusPage />} />
          <Route path="banking" element={<BankingPage />} />
          <Route path="exports" element={<ExportsPage />} />
        </Route>

        {/* Coming Soon */}
        <Route path="/coming-soon" element={<ComingSoonPage />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

